<template>
  <v-app>
    <v-main>
      <router-view />
     
    </v-main>
     <Footer v-if="$route.path!='/c/dashboard' && $route.path!='/c/incident' && $route.path!='/c/incident/create'" />
  </v-app>
</template>

<script>
import Footer from './components/Footer.vue';
export default {
  components: { Footer },
  name: "App",

  data: () => ({
    //
  }),
};
</script>
